import metallurgist from './metallurgist.png';
import builder from './builder.png';
import carpenter from './carpenter.png';
import beginner from './beginner.png';
import bundleFallback from './bundleFallback.png';

const bundles = {
  metallurgist,
  builder,
  carpenter,
  beginner,
  bundleFallback,
}

export { bundles };